export function getFieldOwnerLabel(owner) {
  if (!owner) return '';
  const identity = owner.display_name || `User ${owner.id}`;
  return owner.is_current_user ? "My Fields" : identity;
}
